import { BoosterandBlockerPageCard } from '@screens/HomePage/MyBoosterandBlockerPage/BosterandBlockerPageCard';
import { ReturnButton } from '@/components/shared/ReturnButton';
import { useGetNutritionSummaryList } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { cn } from '@/utils/styles';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';

export const BoostersAndBlockersPage = () => {
  const {
    data: nutritionSummaryListData,
    isLoading,
    isError,
  } = useGetNutritionSummaryList();

  const sortedNutritionSummaryList = nutritionSummaryListData?.sort(
    (a, b) => a.ordinal - b.ordinal,
  );

  if (isError) {
    return <ErrorLoadingPage />;
  }

  if (isLoading) {
    return (
      <section className="page-container">
        <div className="min-h-screen bg-background-secondary">
          <div className="p-6">
            <ReturnButton />

            <h1 className="typography-d2 text-primary mt-10">
              My Boosters & Blockers
            </h1>
          </div>

          <div className="px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
              {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton
                  key={index}
                  className={cn('w-full h-20 rounded-md animate-pulse')}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!nutritionSummaryListData?.length) {
    return;
  }

  return (
    <section className="page-container">
      <div className="min-h-screen bg-background-secondary">
        <div className="p-6">
          <ReturnButton />

          <h1 className="typography-d2 text-primary mt-10">
            My Boosters & Blockers
          </h1>
        </div>

        <div className="px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            {sortedNutritionSummaryList?.map((item) => (
              <BoosterandBlockerPageCard
                key={item.id}
                id={item.id}
                title={item.title}
                count={item.no_of_recommendations}
                imageUrl={item.image_url}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
